"use client";

import { create } from 'zustand';

interface FullPageLoaderOverlayStore {
    open: boolean;
    isLoading: boolean;
    setShowDialog: (show: boolean) => void;
    setLoading: (loading: boolean) => void;
    showFullPageLoaderOverlay: (props: {
        open: boolean;
        isLoading: boolean;
    }) => void;
}

export const useFullPageLoaderOverlayStore = create<FullPageLoaderOverlayStore>((set) => ({
    open: false,
    isLoading: false,
    setShowDialog: (show) => set({ open: show }),
    setLoading: (loading) => set({ isLoading: loading }),
    showFullPageLoaderOverlay: ({ open, isLoading }) => set({
        open,
        isLoading,
    }),
}));